import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { H3 } from 'components/common/Text/Text'
import Link from 'components/common/Link/Link'
import { STORE_LOCATOR_PAGE } from 'constant'
import { formatPhoneNumber } from 'helpers/phone-number'


const BOTContactInfoEVPage = ({ storePhoneNumber }) =>
  <Wrapper>
    <SubTitle headline centered>
      Got EV questions? We&rsquo;ve got answers.
    </SubTitle>

    <ContactInfo>
      Our experts are here to walk you through all your options for new EV tires.
    </ContactInfo>

    {Boolean(storePhoneNumber) && (
      <ContactInfo>
        Please contact your store at <a href={ `tel:+1${storePhoneNumber}` }>{ formatPhoneNumber(storePhoneNumber) }</a> for assistance.
      </ContactInfo>
    )}

    {Boolean(!storePhoneNumber) && (
      <ContactInfo>
        Please <Link to={ STORE_LOCATOR_PAGE }>Select a Store</Link> to continue.
      </ContactInfo>
    )}
  </Wrapper>

BOTContactInfoEVPage.propTypes = {
  storePhoneNumber: PropTypes.string
}

export default BOTContactInfoEVPage

const Wrapper = styled.div`
  width: calc(100vw - 18px);
  max-width: 100vw;
  margin-top: 70px;
  margin-left: calc(50% - 50vw + 9px);
  padding: 80px 16px 90px;
  background: #f2f2f2;
`

const SubTitle = styled(H3)`
  margin: 0 0 25px;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
`

const ContactInfo = styled.p`
  text-align: center;
  line-height: 1.6;
`
